import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Box, BlockStack, Text, Button } from "@/lib/polaris";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  // Si el usuario venía del preview de la tienda, "Volver al inicio" debe llevar al preview, no al panel admin
  const homeHref = (() => {
    try {
      const previewHome = sessionStorage.getItem('previewHome');
      if (previewHome) return previewHome;
    } catch (_) { /* ignore */ }
    return '/';
  })();

  return (
    <Box
      minHeight="100vh"
      padding="800"
      background="bg-fill"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <BlockStack gap="400">
        <Text as="h1" variant="heading2xl">
          404
        </Text>
        <Text as="p" variant="bodyLg" tone="subdued">
          Oops! Página no encontrada
        </Text>
        <Button url={homeHref}>
          Volver al inicio
        </Button>
      </BlockStack>
    </Box>
  );
};

export default NotFound;
